module.exports = __webpack_public_path__ + "img/Miscellaneous-low.12e03404.jpg";